module.exports = __webpack_public_path__ + "img/dGJhAAMb.09495154.svg";